import type { Theme } from './theme';

/** Where a returning visitor's choice is kept, beside the language under its own key. */
export const THEME_STORAGE_KEY = 'theme';

/** The class the `dark` variant in `tailwind.css` is defined against, put on `<html>`. */
export const DARK_CLASS = 'dark';

export function isTheme(value: string | null | undefined): value is Theme {
    return value === 'light' || value === 'dark';
}

/**
 * Which appearance to open in: the one the visitor chose last time, or light.
 *
 * **Light rather than `prefers-color-scheme`, deliberately.** Dark is a choice here and not yet a
 * second skin for the whole site — the ported landing, booking and legal pages have one appearance,
 * and the portal and the blog have had no dark pass — so following the operating system would hand
 * a half-dark site to visitors who never asked for one. That changes the day the rest of the pages
 * can answer it, and it changes here, in one line, for the bundle and for the inline script in
 * `index.html` that repeats this rule before first paint.
 *
 * **Pure, and it has to stay that way** — the same rule its neighbours in `core/i18n` follow, and
 * for the same reason: this compiles under the build's Node project, which has no DOM. The reading
 * of storage and of the class lives in `app/theme-memory.ts`.
 */
export function preferredTheme(remembered: string | null | undefined): Theme {
    return isTheme(remembered) ? remembered : 'light';
}
